import {
  formatDateTime,
  dateTimeStringToDate,
} from "../../../../../common/helpers/time";
import forEach from "lodash/forEach";
import cloneDeep from "lodash/cloneDeep";
class AdminInstructorsEditAvailabilityController {
  constructor($state, $stateParams, UsersModel, FlashService) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.UsersModel = UsersModel;
    this.FlashService = FlashService;
    this.busy = false;
    this.availability = {
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: [],
    };

    this.updateAvailability = this.updateAvailability.bind(this);

    const today = new Date();
    this.today = formatDateTime(today, "M/DD/YYYY");

    UsersModel.getInstructorByID($stateParams.instructorId).then((response) => {
      this.instructor = response;
      forEach(this.instructor.usermeta.availability, (range, day) => {
        forEach(range, (values, index) => {
          range[index].from = new Date(`${this.today} ${values.from}`);
          range[index].to = new Date(`${this.today} ${values.to}`);
        });
        this.availability[day] = range;
      });
    });
  }

  editInstructorAvailability() {
    const availability = {};
    this.busy = true;
    forEach(cloneDeep(this.availability), (range, day) => {
      forEach(range, (values, index) => {
        range[index].from = formatDateTime(values.from, "HH:mm");
        range[index].to = formatDateTime(values.to, "HH:mm");
      });
      availability[day] = range;
    });

    this.UsersModel.updateInstructorAvailability(
      this.instructor.id,
      availability,
    )
      .then((response) => {
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        this.busy = false;
        this.$state.go("drivecoach.admin.instructors.view", {
          instructorId: response.usermeta.user_id,
        });
      })
      .catch((error) => {
        this.busy = false;
      });
  }

  addSlot(day) {
    const fromTime = new Date();
    fromTime.setHours(8, 0, 0, 0);
    const toTime = new Date();
    toTime.setHours(17, 0, 0, 0);

    this.availability[day].push({
      from: fromTime,
      to: toTime,
    });
  }

  removeSlot(day, index) {
    this.availability[day].splice(index, 1);
  }

  updateAvailability(data) {
    const day_of_week = data.name.split("_")[0];
    const from_or_to = data.name.split("_")[1];

    this.availability[day_of_week][data.index][from_or_to] = data.selected[0];
  }
}
AdminInstructorsEditAvailabilityController.$inject = [
  "$state",
  "$stateParams",
  "UsersModel",
  "FlashService",
];
export default AdminInstructorsEditAvailabilityController;
